export default __webpack_public_path__ + "static/media/josua.10893bb1.png";